import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BigPicklistInput } from 'Packages/FacetDesign/Components';
import { FDDialogTitle } from '@facet-wealth/design';

export default buildFacetDesignOverride()
  .nameOverride('title', { _component: () => FDDialogTitle }, overrideReadOnly)
  .nameOverride('incomeType', { _component: () => BigPicklistInput }, { ordinal: 200 });
